<template>
  <div style="position: relative; width: 100%; height: auto">
    <player
      :isMobile="isMobile"
      :activeIndex="activeIndex"
      :class="
        isMobile ? 'player' : activeIndex % 5 == 0 ? 'player' : 'player-fixed'
      "
    />
    <div class="main-news-wrapper">
      <div class="inner" ref="inner">
        <div
          :class="(activeIndex + 1) % 3 == 0 ? 'scale' : 'no-scale'"
          class="bg-spaces"
        ></div>

        <template v-if="latestNews.length > 0">
          <template v-for="(list, index) in latestNews" :key="index">
            <div class="spacer"></div>
            <component
              :is="
                list.length !== pageSize
                  ? isMobile
                    ? 'mobileBar0'
                    : 'bar0'
                  : `${isMobile ? 'mobileB' : 'b'}ar${index
                      .toString()
                      .substr(-1)}`
              "
              :isActive="isMobile ? true : activeIndex === index"
              :id="`ind${index}`"
              :list="list"
              :scrollUp="scrollUp"
              transition-mode="out-in"
            />
          </template>
        </template>
      </div>
      <svg
        width="0"
        height="0"
        viewBox="0 0 416 350"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <clipPath id="cardFirstClip" clipPathUnits="objectBoundingBox">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.228,0.002 C0.155,0.04,0.09,0.104,0.051,0.185 C0.016,0.26,0.024,0.345,0.033,0.432 C0.037,0.475,0.042,0.518,0.041,0.561 C0.04,0.606,0.03,0.653,0.02,0.7 C0.001,0.795,-0.018,0.888,0.033,0.952 C0.087,1,0.169,1,0.252,0.988 C0.293,0.981,0.334,0.973,0.372,0.975 C0.388,0.976,0.403,0.977,0.419,0.978 C0.479,0.981,0.538,0.985,0.6,0.981 C0.634,0.979,0.67,0.983,0.706,0.988 C0.788,0.997,0.87,1,0.927,0.943 C0.988,0.875,0.985,0.768,0.982,0.662 C0.98,0.628,0.979,0.594,0.981,0.561 C0.982,0.526,0.986,0.489,0.99,0.452 C1,0.343,1,0.232,0.956,0.154 C0.906,0.087,0.829,0.087,0.75,0.088 C0.705,0.088,0.659,0.088,0.618,0.076 C0.592,0.068,0.568,0.057,0.544,0.044 C0.508,0.061,0.452,0.072,0.406,0.059 C0.403,0.057,0.391,0.058,0.375,0.059 C0.347,0.061,0.308,0.064,0.298,0.047 C0.276,0.037,0.265,0.038,0.259,0.039 C0.254,0.039,0.251,0.04,0.248,0.035 C0.226,0.029,0.228,0.025,0.23,0.02 C0.232,0.016,0.234,0.013,0.229,0.009 C0.228,0.007,0.228,0.004,0.228,0.002"
          />
        </clipPath>
        <clipPath id="cardSecondClip" clipPathUnits="objectBoundingBox">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.258,0.101 C0.343,0.123,0.454,0.076,0.454,0.048 C0.454,0.04,0.448,0.029,0.435,0.019 C0.461,0.024,0.487,0.028,0.512,0.028 C0.545,0.029,0.58,0.022,0.615,0.014 C0.68,0,0.744,-0.014,0.794,0.029 C0.842,0.069,0.848,0.138,0.854,0.209 C0.858,0.252,0.862,0.296,0.876,0.335 C0.889,0.371,0.912,0.404,0.935,0.436 C0.971,0.488,1,0.538,0.999,0.601 C0.99,0.675,0.933,0.723,0.877,0.77 C0.857,0.786,0.837,0.803,0.819,0.821 C0.813,0.828,0.806,0.834,0.8,0.841 C0.748,0.894,0.696,0.947,0.63,0.973 C0.553,1,0.471,1,0.389,0.994 C0.375,0.992,0.361,0.99,0.346,0.988 C0.264,0.979,0.178,0.969,0.121,0.904 C0.072,0.847,0.065,0.767,0.057,0.686 C0.054,0.656,0.051,0.626,0.046,0.597 C0.041,0.567,0.034,0.537,0.027,0.507 C0.007,0.425,-0.013,0.343,0.011,0.264 C0.033,0.194,0.074,0.131,0.126,0.084 C0.129,0.085,0.133,0.086,0.138,0.089 C0.149,0.106,0.193,0.103,0.224,0.1 C0.241,0.099,0.255,0.098,0.258,0.101"
          />
        </clipPath>
        <clipPath id="cardThirdClip" clipPathUnits="objectBoundingBox">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.171,0.29 C0.092,0.351,0.014,0.411,0.002,0.517 C-0.016,0.682,0.084,0.845,0.203,0.938 C0.274,0.993,0.358,0.981,0.444,0.968 C0.484,0.962,0.524,0.956,0.564,0.957 C0.606,0.958,0.65,0.969,0.693,0.979 C0.785,1,0.874,1,0.939,0.953 C1,0.876,1,0.753,0.993,0.632 C0.99,0.593,0.987,0.554,0.986,0.517 C0.986,0.488,0.987,0.458,0.987,0.428 C0.99,0.307,0.992,0.187,0.93,0.092 C0.852,-0.025,0.733,-0.005,0.608,0.016 C0.593,0.018,0.579,0.021,0.564,0.023 C0.559,0.024,0.553,0.025,0.547,0.026 C0.574,0.033,0.587,0.05,0.587,0.061 C0.587,0.083,0.504,0.119,0.44,0.102 C0.437,0.099,0.427,0.1,0.414,0.101 C0.401,0.102,0.385,0.104,0.372,0.102 C0.345,0.125,0.317,0.154,0.284,0.191 C0.251,0.229,0.211,0.259,0.171,0.29"
          />
        </clipPath>
        <clipPath id="cardFourthClip" clipPathUnits="objectBoundingBox">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.665,0 C0.63,0,0.594,0.004,0.558,0.008 C0.551,0.008,0.544,0.009,0.536,0.01 C0.441,0.02,0.351,0.047,0.275,0.114 C0.252,0.134,0.226,0.154,0.199,0.173 C0.117,0.232,0.03,0.294,0.034,0.394 C0.035,0.44,0.027,0.495,0.018,0.552 C0.001,0.662,-0.018,0.778,0.034,0.842 C0.1,0.924,0.308,0.958,0.449,0.98 C0.483,0.986,0.513,0.991,0.536,0.995 C0.664,1,0.791,0.932,0.88,0.822 C0.967,0.714,1,0.567,0.999,0.42 C0.994,0.305,0.959,0.191,0.893,0.107 C0.864,0.112,0.833,0.112,0.804,0.104 C0.801,0.102,0.788,0.103,0.771,0.104 C0.739,0.107,0.696,0.11,0.684,0.092 C0.661,0.08,0.649,0.082,0.642,0.082 C0.636,0.083,0.633,0.083,0.63,0.078 C0.605,0.072,0.607,0.067,0.61,0.062 C0.612,0.058,0.614,0.054,0.608,0.05 C0.603,0.028,0.628,0.01,0.665,0"
          />
        </clipPath>
        <clipPath id="cardFivthClip" clipPathUnits="objectBoundingBox">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.621,0.045 C0.603,0.064,0.537,0.087,0.484,0.073 C0.482,0.071,0.472,0.072,0.46,0.073 C0.437,0.075,0.406,0.077,0.398,0.065 C0.381,0.057,0.372,0.058,0.367,0.058 C0.363,0.059,0.361,0.059,0.359,0.055 C0.341,0.051,0.343,0.048,0.345,0.044 C0.346,0.042,0.347,0.039,0.343,0.036 C0.339,0.02,0.36,0.007,0.391,0 C0.291,-0.003,0.192,0.015,0.118,0.087 C0.011,0.194,-0.001,0.369,0,0.528 C0.001,0.685,0.012,0.866,0.126,0.961 C0.198,1,0.287,0.999,0.378,0.978 C0.425,0.968,0.473,0.957,0.519,0.956 C0.566,0.956,0.614,0.968,0.661,0.979 C0.753,1,0.842,1,0.91,0.958 C1,0.861,1,0.679,0.989,0.528 C0.973,0.398,0.903,0.291,0.819,0.199 C0.76,0.134,0.695,0.079,0.621,0.045"
          />
        </clipPath>
      </svg>
      <div
        v-if="show.spinner"
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 44px 0;
        "
        :style="{ height: latestNews.length > 0 ? 'unset' : '80vh' }"
      >
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  computed,
  reactive,
  watch,
  onMounted,
  onBeforeUnmount,
  defineAsyncComponent
} from "vue";

const MainBar = defineAsyncComponent(() =>
  import("@/components/lifestyle/MainBar")
);
const MobileMainBar = defineAsyncComponent(() =>
  import("@/components/lifestyle/mobile/MainBar")
);

import FirstBar from "@/components/lifestyle/FirstBar";

const SecondBar = defineAsyncComponent(() =>
  import("@/components/lifestyle/SecondBar")
);
const MobileSecondBar = defineAsyncComponent(() =>
  import("@/components/lifestyle/mobile/SecondBar")
);

const ThirdBar = defineAsyncComponent(() =>
  import("@/components/lifestyle/ThirdBar")
);
const MobileThirdBar = defineAsyncComponent(() =>
  import("@/components/lifestyle/mobile/ThirdBar")
);

const FourthBar = defineAsyncComponent(() =>
  import("@/components/lifestyle/FourthBar")
);
const MobileFourthBar = defineAsyncComponent(() =>
  import("@/components/lifestyle/mobile/FourthBar")
);

import Player from "@/components/lifestyle/Player";
// import FivthBar from "@/components/media/FivthBar";
import { useStore } from "vuex";
import { useInfiniteScroll } from "@/utils/infiniteScroll";

export default {
  components: {
    bar0: MainBar,
    bar1: FirstBar,
    bar2: SecondBar,
    bar3: ThirdBar,
    bar4: FourthBar,

    bar5: MainBar,
    bar6: FirstBar,
    bar7: SecondBar,
    bar8: ThirdBar,
    bar9: FourthBar,

    mobileBar0: MobileMainBar,
    mobileBar1: FirstBar,
    mobileBar2: MobileSecondBar,
    mobileBar3: MobileThirdBar,
    mobileBar4: MobileFourthBar,

    mobileBar5: MobileMainBar,
    mobileBar6: FirstBar,
    mobileBar7: MobileSecondBar,
    mobileBar8: MobileThirdBar,
    mobileBar9: MobileFourthBar,

    Player
  },
  setup() {
    const store = useStore();
    const inner = ref(null);
    const show = reactive({
      spinner: true
    });

    const activeIndex = ref(0);

    const checkWidth = () => {
      if (typeof window !== "undefined") {
        isMobile.value = window.innerWidth <= 992;
      }
    };

    const isMobile = ref(
      typeof window !== "undefined" ? window.innerWidth <= 992 : false
    );
    // TODO screen change & if window !== undefined

    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function() {
          resizeTimeout = null;
          checkWidth();
          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }

    const touchStart = event => {
      if (!isMobile.value) {
        touchstartX = event.changedTouches[0].screenX;
        touchstartY = event.changedTouches[0].screenY;
      }
    };

    const touchEnd = event => {
      if (!isMobile.value) {
        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY;
        handleGesture();
      }
    };

    const scrollEnd = () => {
      show.spinner = false;
    };

    const pageSize = 5;

    const { loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getLatestNews", {
          pageSize,
          cb: () => cb(),
          category: "lifestyle",
          load
        });
      },
      newsCount: computed(() => store.getters.newsCount),
      currentPage: computed(() => store.getters.currentPage),
      pageSize,
      scrollEnd,
      isMobile
    });

    const refreshData = () => {
      store.commit("flushArticleState");

      show.spinner = true;
      loadData();
    };

    refreshData();

    const scrollUp = ref(false);

    const height = typeof window !== "undefined" ? window.innerHeight : 980;

    function handleScrollUp(height) {
      if (typeof window !== "undefined") {
        window.scrollBy({
          top: -height
        });
      }
    }
    function handleScrollDown(height) {
      if (typeof window !== "undefined") {
        window.scrollBy({
          top: height
        });
      }
    }
    let timeScroll;
    const wheelEventHandler = e => {
      clearTimeout(timeScroll);
      timeScroll = setTimeout(() => {
        let delta = e.wheelDelta;
        if (delta > 0) {
          //go up
          handleScrollUp(height);
          scrollUp.value = true;
        } else {
          //go down
          handleScrollDown(height);
          scrollUp.value = false;
        }
      }, 500);
    };

    const onScroll = () => {
      activeIndex.value = Math.ceil(window.scrollY / window.innerHeight);
    };

    function fixScrollBehavior(elem) {
      if (!isMobile.value) {
        elem.addEventListener("wheel", wheelEventHandler);
        elem.addEventListener("scroll", onScroll);
      }
    }

    let scrollTimeout;

    /* eslint-disable */
    let touchstartX;
    let touchstartY;
    let touchendX;
    let touchendY;
    function handleGesture() {
      if (touchendY < touchstartY) {
        scrollUp.value = false;
        onScroll();
        handleScrollDown(height);
      }

      if (touchendY > touchstartY) {
        scrollUp.value = true;
        onScroll();
        handleScrollUp(height);
      }
    }

    /* eslint-enable */

    onMounted(() => {
      if (typeof window !== "undefined") {
        document
          .querySelector("html")
          .setAttribute("data-scroll", "scrollPage");
        checkWidth();
        window.addEventListener("resize", resizeThrottler, false);
        window.addEventListener("touchstart", touchStart);
        window.addEventListener("touchend", touchEnd);
        fixScrollBehavior(window);
      }
    });
    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        document.querySelector("html").removeAttribute("data-scroll");
        window.removeEventListener("resize", resizeThrottler);
        window.removeEventListener("wheel", wheelEventHandler);
        window.removeEventListener("touchstart", touchStart);
        window.removeEventListener("touchend", touchEnd);
        clearTimeout(scrollTimeout);
      }
    });

    let biggestVal = 0;
    watch(
      () => activeIndex.value,
      (newVal, oldVal) => {
        if (newVal > oldVal) {
          if (biggestVal < newVal) {
            biggestVal = newVal;
          }
        }
      }
    );

    return {
      inner,
      show,
      pageSize,
      latestNews: computed(() => store.getters.latestNews),
      activeIndex,
      isMobile,
      scrollUp
    };
  }
};
</script>

<style lang="scss">
html[data-scroll="scrollPage"] {
  --primary-font-color: #fff;
  height: 100vh;
  overflow: hidden;
  scroll-behavior: smooth;
  scroll-snap-type: y mandatory;
  @media screen and (max-width: 992px) {
    overflow: visible;
  }
  .spacer {
    position: relative;
    width: 100%;
    height: 100vh;
    scroll-snap-align: start;
    z-index: -1;
    @media screen and (max-width: 992px) {
      display: none;
    }
  }
}
</style>

<style lang="scss" scoped>
.scale {
  transform: scale(1.5);
  transition: transform 0.6s ease-in;
}
.no-scale {
  transform: scale(1);
  transition: transform 0.6s ease-in;
}
.bg-spaces {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  background: url("../assets/lifestyle-page/space.jpg") no-repeat;
  background-size: cover;
  transition: transform 0.6s ease-in;
  z-index: -1;
  @media screen and (max-width: 992px) {
    display: none;
  }
}

.main-news-wrapper {
  --width-life: 95%;
  --category-color: rgba(18, 18, 18, 0.7);
  --black-text: #121212;
  --data-color: rgba(18, 18, 18, 0.8);

  width: 100%;
  margin: 0 auto;
  position: relative;
  .inner {
    position: relative;
    width: 100%;
    height: auto;
    display: block;
    flex-direction: column;
    align-items: center;
    margin-bottom: 3.125rem;
    overflow: hidden;

    :deep().absolute-block {
      position: fixed;
      left: 0;
      height: 100vh;
      min-height: 100vh;
      width: 100%;
      top: 0;
      @media screen and (max-width: 992px) {
        position: relative;
      }
    }

    :deep() .card {
      &__title {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 19px;
        line-height: 24px;
      }
      .data-news {
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        margin-top: 7px;
      }
      &__category-img {
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
      }
      &__category,
      &__category-title {
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
      }
      &__brief {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 17px;
        line-height: 150%;
      }
      .data-news-brief {
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        text-align: right;
      }
      &__img {
        :deep() .main-image img {
          border-radius: 0px;
          overflow: visible;
        }
      }
      @media screen and (max-width: 992px) {
        &__title {
          font-size: 16px;
          line-height: 22px;
        }
        .data-news {
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 18px;
        }
        &__category {
          text-transform: uppercase;
        }
        &__category-img {
          font-style: normal;
          font-weight: 600;
          font-size: 13px;
          line-height: 18px;
          text-transform: uppercase;
        }
        &__category-descr {
          font-style: normal;
          font-weight: 600;
          font-size: 13px;
          line-height: 18px;
          text-transform: uppercase;
          margin-bottom: 0.25rem;
        }
        &__brief {
          font-weight: 300;
          font-size: 14px;
          line-height: 150%;
        }
        .data-news-brief {
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          margin-top: 8px;
        }
      }
      @media screen and (max-width: 767px) {
        &__title {
          font-size: 16px;
          line-height: 20px;
        }
        .data-news {
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
        }
        &__category-img {
          font-style: normal;
          font-weight: 600;
          font-size: 12px;
          line-height: 14px;
        }
        &__category-descr {
          font-weight: 600;
          font-size: 10px;
          line-height: 14px;
          text-transform: uppercase;
          margin-bottom: 0.25rem;
        }
        &__brief {
          font-weight: 300;
          font-size: 14px;
          line-height: 150%;
        }
        .data-news-brief {
          font-weight: normal;
          font-size: 10px;
          line-height: 14px;
        }
      }
    }
  }
}
.player-fixed {
  position: fixed;
  top: 15vh;
  left: 50%;
  transform: translateX(-50%);
  width: 380px;
  height: 48px;
  transition: 0.6s;
  font-size: 1.2rem;

  z-index: 100;
  animation: playerPosition 1.2s;
}
.player {
  width: 480px;
  height: 80px;
  position: fixed;
  top: 74vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  transition: 0.6s;
  font-size: 1.5rem;
}
@media screen and (max-width: 1500px) {
  .player {
    left: 49%;
  }
}
@media screen and (max-width: 992px) {
  .player {
    max-width: 435px;
    top: 10%;
  }
}
@media screen and (max-width: 767px) {
  .player {
    max-width: 100%;
    top: 8%;
  }
}
@media screen and (max-width: 600px) {
  .player {
    width: 375px;
    top: 8%;
  }
}
/* ----------- iPad Pro ----------- */
/* Portrait and Landscape */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
}

/* Portrait */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
  .player {
    left: 50%;
    top: auto;
    bottom: 12%;
  }
  .player-fixed {
    position: fixed;
    top: 10vh;
    left: 50%;
  }
}

/* Landscape */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1.5) {
  .player-fixed {
    top: 11vh;
  }
}
</style>
<style lang="scss" scoped>
@keyframes playerPosition {
  0% {
    top: 73%;
  }
  50% {
    top: 50%;
  }
  100% {
    top: 20%;
  }
}
</style>
